/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button, DialogActions } from "@mui/material";

const DeleteDialogActions = (props) => {
    const handleCancel = props.handleCancel;
    const handleRemove = props.handleRemove;
    // const deleteType = props.deleteType

    return (
        <Fragment>
            <DialogActions>
                <Button variant='outlined' color='secondary' onClick={handleCancel}>
                    Cancel
                </Button>

                {/*{deleteType === 'DELETE' && (*/}
                {/*    <Button variant='contained' color='warning' onClick={handleDelete}>*/}
                {/*        Delete*/}
                {/*    </Button>*/}
                {/*)}*/}
                <Button variant='contained' color='secondary' onClick={handleRemove}>
                    Remove
                </Button>
                {/*)}*/}
            </DialogActions>
        </Fragment>
    );
};

export default DeleteDialogActions;
